const {Component} = require("react");
const PropTypes = require("prop-types");
const router = require("services/router");
const userStore = require("stores/UserStore");
const echo = require("services/echo");
const {classList} = require("helpers/html");
const {debounce} = require("helpers/throttle");

class InboxLink extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string,
			url: PropTypes.string,
			icon: PropTypes.string,
			counter: PropTypes.number
		};
	}

	static get defaultProps() {
		return {
			title: "Inbox",
			url: "#",
			icon: "inbox",
			counter: 0
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			counter: props.counter,
			shadowCounter: props.counter
		};
	}

	componentDidMount() {
		this.listenForMessageCreated();
		this.listenForMessageRead();
	}

	get iconUrl() {
		return router.url(`img/icons/${this.props.icon}.svg`);
	}

	get className() {
		return classList(
			(this.state.counter === 0) && "empty"
		);
	}

	listenForMessageCreated() {
		echo.userState(userStore.get("id")).listen("App\\Events\\Chat\\MessageCreated", (e) => {
			this.increaseCounter()
		});
	}

	listenForMessageRead() {
		echo.userState(userStore.get("id")).listen("App\\Events\\Chat\\MessageRead", (e) => {
			this.decreaseCounter()
		});
	}

	updateCounter = debounce(250, () => {
		this.setState({counter: this.state.shadowCounter});
	});

	increaseCounter() {
		this.setState({shadowCounter: this.state.shadowCounter + 1}, () => this.updateCounter());
	}

	decreaseCounter() {
		this.setState({shadowCounter: Math.max(0, this.state.shadowCounter - 1)}, () => this.updateCounter());
	}

	render() {
		return (
			<a href={this.props.url} className={this.className}>
				<img src={this.iconUrl} alt={this.props.title}/>
				{this.props.title}
				<span>{this.state.counter}</span>
			</a>
		);
	}

}

module.exports = InboxLink;


// WEBPACK FOOTER //
// ./resources/js/components/backend/InboxLink.js